import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { resetPasswordForEmail } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Por favor ingresa tu correo electrónico.');
      return;
    }
    setLoading(true);
    setError('');
    const { error: err } = await resetPasswordForEmail(email);
    setLoading(false);
    if (err) {
      setError('No pudimos enviar el correo. Verifica la dirección e intenta de nuevo.');
    } else {
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-lg md:rounded-xl shadow-elevation-lg p-6 md:p-8 lg:p-10">

          {/* Header */}
          <div className="text-center mb-6 md:mb-8">
            <div className="flex justify-center mb-4 md:mb-6">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-accent/10 flex items-center justify-center">
                <Icon name="KeyRound" size={32} className="text-accent" />
              </div>
            </div>
            <h1 className="text-2xl md:text-3xl font-semibold text-foreground mb-2">
              ¿Olvidaste tu contraseña?
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Ingresa tu correo y te enviaremos un enlace para restablecerla.
            </p>
          </div>

          {sent ? (
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="w-14 h-14 rounded-full bg-green-500/10 flex items-center justify-center">
                  <Icon name="MailCheck" size={28} className="text-green-500" />
                </div>
              </div>
              <p className="text-sm text-foreground font-medium">
                Correo enviado a <span className="text-accent">{email}</span>
              </p>
              <p className="text-sm text-muted-foreground">
                Revisa tu bandeja de entrada y haz clic en el enlace para restablecer tu contraseña.
              </p>
              <Button
                variant="outline"
                className="w-full mt-2"
                onClick={() => navigate('/login')}
              >
                Volver al inicio de sesión
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <Input
                label="Correo electrónico"
                type="email"
                placeholder="tu@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={error}
                autoFocus
              />

              <Button
                type="submit"
                variant="default"
                className="w-full"
                loading={loading}
              >
                Enviar enlace de restablecimiento
              </Button>
            </form>
          )}

          {!sent && (
            <div className="mt-5 text-center">
              <button
                onClick={() => navigate('/login')}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                ← Volver al inicio de sesión
              </button>
            </div>
          )}
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} CatalogFlip. {t('embedSettings.footer.rights')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
